import { dataTaskListSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTaskListSolid = /*#__PURE__*/createIcon(dataTaskListSolid)
export default IconTaskListSolid
